import NewsForm from "@/components/cms/NewsForm";
import StyledDrawer from "@/components/StyledDrawer";
import { NewsItem } from "@/lib/cms/cms-types";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";
import { cmsPhrase } from "@/lib/cms/cms-new-phrases";
import { ReactNode, useState } from "react";

/**
 * Drawer création / édition d'une actualité — même UI que `/cms/news`
 * et `/cms/advanced/news` (réutilise `NewsForm`).
 */
export function NewsItemDrawer({
  trigger,
  newsItem,
  refetch,
  title,
  onCreated,
}: {
  trigger: ReactNode;
  newsItem?: NewsItem;
  refetch: () => void;
  /** Titre du drawer ; défaut = Ajouter / Modifier selon le contexte. */
  title?: string;
  /** Appelé après une création réussie (ex. auto-sélection dans le picker). */
  onCreated?: (item: NewsItem) => void;
}) {
  const cmsNew = useCmsNew();
  const [open, setOpen] = useState(false);
  const resolvedTitle =
    title ??
    (newsItem
      ? cmsPhrase(cmsNew, "newsEditTitle")
      : cmsPhrase(cmsNew, "newsAddTitle"));

  return (
    <StyledDrawer
      className="overflow-y-auto"
      title={resolvedTitle}
      trigger={trigger}
      maxWidth="sm:max-w-xl"
      sheetProps={{ open, onOpenChange: setOpen }}
      contentProps={{ onInteractOutside: (e) => e.preventDefault() }}
    >
      <NewsForm
        newsItem={newsItem}
        refetch={refetch}
        onSuccess={(item) => {
          setOpen(false);
          if (!newsItem?.id && item?.id) onCreated?.(item);
        }}
      />
    </StyledDrawer>
  );
}
